module.exports = __webpack_public_path__ + "img/pic_Jurisdiction@2x_1.c94a3460.png";